import { PERMISSION_LIST } from "./PermissionTypes";

export const permissionListAction = (payload: string[]) => {
  return {
    type: PERMISSION_LIST,
    payload,
  };
};
